export default __webpack_public_path__ + "static/media/chapter10.44015f2e.svg";